import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getLeads } from "../redux/leadsSlice";
import DealCard from "./ui/DealCard";
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { LiveDealsSliderSkeleton } from "./ui/skeleton/LiveDealsSkeleton";
import useScreenSize from "../hooks/useScreenSize";

const Leads = () => {
  const dispatch = useDispatch();
  const { data: leads = [], status, currentType } = useSelector((state) => state.leads);
  const { isMobile } = useScreenSize();

  // external arrow controls
  const sliderRef = useRef(null);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    cssEase: 'linear',
    slidesToShow: isMobile ? 1 : 4,
    slidesToScroll: 1
  };

  useEffect(() => {
    if (currentType !== 'hot') {
      dispatch(getLeads({ page: 1, type: "hot" }));
    }
    // console.log('Current leads:', leads);
  }, [dispatch, currentType]);

  return (
    <div className="row">
      <div className="col-12">
        <div className="d-flex align-items-center justify-content-center position-relative mt-3 mb-3">
          <h2 className='heading mb-1 mt-1 mb-md-2 mb-lg-2 mb-xl-2 mt-md-3 mt-lg-3 mt-xl-3'>Hot Deals</h2>
          <div className="heading-arrows">
            <button
              type="button"
              aria-label="Previous"
              className="heading-arrow-btn"
              onClick={() => sliderRef.current?.slickPrev()}
              disabled={leads.length <= settings.slidesToShow}
            >
              <img src="/images/left-arr.svg" alt="Previous" />
            </button>
            <button
              type="button"
              aria-label="Next"
              className="heading-arrow-btn"
              onClick={() => sliderRef.current?.slickNext()}
              disabled={leads.length <= settings.slidesToShow}
            >
              <img src="/images/right-arr.svg" alt="Next" />
            </button>
          </div>
        </div>
      </div>

      <div className="col-12 ps-3 pe-3">
        {status === 'loading' && <LiveDealsSliderSkeleton />}
        {status === 'failed' && <p>Failed to load leads.</p>}
        {status === 'succeeded' && leads.length === 0 && <p>No leads available.</p>}
        {status === 'succeeded' && leads.length > 0 && (
          <div className="container p-0">
            <Slider ref={sliderRef} {...settings}>
              {leads.map((lead, index) => (
                <div className="slick-card" key={lead.name || index}>
                  <DealCard lead={lead} />
                </div>
              ))}
            </Slider>
          </div>

        )}
      </div>
    </div>
  );
};

export default Leads;